import script from "./FileThumb.vue?vue&type=script&setup=true&lang=js"
export * from "./FileThumb.vue?vue&type=script&setup=true&lang=js"

import "./FileThumb.vue?vue&type=style&index=0&id=4ad0eafa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ad0eafa"]])

export default __exports__